<template>
  <!-- <div style="background-color: #fff"> -->
  <div class="personalBox">
    <div class="navListBox">
      <!-- <div class="navListBox_top">
          <img
            class="navListBox_topImg"
            src="/static/image/userImg.png"
            alt=""
          />
          <span class="navListBox_topText">采购人中心</span>
        </div> -->
      <div v-for="(item, index) in navList" :key="index" class="navList_list">
        <div class="navList_title">
          <!-- <img :src="item.icon" alt="" /> -->
          <span>{{ item.title }}</span>
        </div>
        <div :class="['navList_item', $route.path == it.url ? 'active' : '']" v-for="it in item.list" :key="it.url" v-if="it.isShow" @click="
            $router.push(it.url);
            chooseTitle = it.title;
          ">
          {{ it.title }}
        </div>
      </div>
    </div>
    <router-view style="flex: 1" :title="chooseTitle" />
  </div>
  <!-- </div> -->
</template>
<script>
export default {
  data() {
    return {
      navList: [
        //侧边栏列表
        {
          title: "订单中心",
          // icon: "/static/image/orderIcon.png",
          list: [
            { title: "我的订单", url: "/myOrder", isShow: true },
            { title: "收藏商品", url: "/myCollection", isShow: true },
            { title: "我的发票", url: "/myInvoice", isShow: true },
            // { title: "我的评价", url: "/myRate", isShow: true },
          ],
        },
        {
          title: "统计",
          // icon: "/static/image/summaryIcon.png",
          list: [{ title: "订单数据汇总", url: "/dataSummary", isShow: true }],
        },
        {
          title: "设置",
          // icon: "/static/image/settingIcon.png",
          list: [
            { title: "手机绑定", url: "/editPhone", isShow: true },
            { title: "修改密码", url: "/editPassword", isShow: true },
            { title: "收货地址", url: "/myAddress", isShow: true },
            { title: "企业资质", url: "/companyInfo", isShow: true },
            {
              title: "子账号管理",
              url: "/subAccount",
              isShow:
                this.$cookies.get("userInfo") &&
                this.$cookies.get("userInfo").parentAccount == "",
            },
          ],
        },
        {
          title: "合同授权",
          // icon: "/static/image/authorizationIcon.png",
          list: [
            { title: "交易合同", url: "/transactionContract", isShow: true },
            { title: "平台授权", url: "/platformAuthorization", isShow: true },
          ],
        },
      ],
      chooseTitle: "",
    };
  },
  mounted() {
    var that = this;
    this.navList.forEach((x) => {
      x.list.forEach((item) => {
        if (item.url == that.$route.path) {
          that.chooseTitle = item.title;
        }
      });
    });
  },
  watch: {
    $route(to, from) {
      var that = this;
      this.navList.forEach((x) => {
        x.list.forEach((item) => {
          if (item.url == that.$route.path) {
            that.chooseTitle = item.title;
          }
        });
      });
    },
  },
  methods: {},
};
</script>
<style scoped>
@import "../../../assets/css/personal/home";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/home.vue